import type { QualityReport } from '../../types/quality'
import { request } from './http'

export const getQualityReport = () => request<QualityReport>('/quality')

export const setBenchmark = ({ recipeId, batchId }: { recipeId: number; batchId: number | null }) =>
	request<{ recipe_id: number; benchmark_batch_id: number | null }>(`/quality/benchmarks/${recipeId}`, {
		method: 'PUT',
		body: JSON.stringify({ batch_id: batchId }),
	})
